export default "__VITE_ASSET__DLB0P_1W__"